import posthog from "posthog-js";
import { isProduction } from "@/Environment";

export function initializePostHog(): void {
  if (!isProduction()) {
    return;
  }

  posthog.init("phc_KihsiQpvUMSqXillnynsVDnLhlKYEIQhCnrF9R9uQS9", {
    api_host: "https://s.freightsimple.com",
    ui_host: "https://us.posthog.com",
    cross_subdomain_cookie: true,
    persistence: "localStorage+cookie",
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    // Errors go to Sentry; see initializeErrorReporting.
    capture_exceptions: false,
    session_recording: {
      maskAllInputs: false,
      maskInputFn: (text, element) => {
        if (element?.getAttribute("type") === "password")
          return "*".repeat(text.length);
        return text;
      },
    },
  });
}
